const skills = {
  Frontend: [
    'HTML/CSS',
    'SCSS',
    'JavaScript(ES6+)/TypeScript',
    'React',
    'React/Redux  Redux/Thunk Redux/Saga',
    'Redux Toolkit/RTK Query',
  ],
  Others: ['Git/Github', 'axios', 'Socket.io', 'npm/yarn', 'Editor JS', 'RESTful'],
};

export default skills;
